/**
 * @description
 * Given two items of any data type, checks if they are both deeply equal to each other
 * by doing a JSON.stringify on both items.
 * */
export const isDeepEqual = (a: unknown, b: unknown) => JSON.stringify(a) === JSON.stringify(b);
